export default "__VITE_ASSET__DZQefHyt__"